import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderCardsArticlesComponent } from './slider-cards-articles.component';
import { CardArticleModule } from '../../cards/card-article/card-article.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SpinnerModule } from '../../loaders/spinner/spinner.module';



@NgModule({
  declarations: [SliderCardsArticlesComponent],
  imports: [CommonModule, CardArticleModule, SwiperModule, SpinnerModule],
  exports: [
    SliderCardsArticlesComponent
  ]
})
export class SliderCardsArticlesModule { }
